import { render, staticRenderFns } from "./TournamentCardHeader.vue?vue&type=template&id=567e4c2d&"
import script from "./TournamentCardHeader.vue?vue&type=script&lang=ts&"
export * from "./TournamentCardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TournamentCardHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VListItem,VListItemAction,VListItemContent,VSpacer})
